export enum Capability {
  PENCIL_FILES = 'PENCIL_FILES',
  SPARKY = 'SPARKY',
  WEB_VIEWER = 'WEB_VIEWER',
  CLOUD_RECORDING = 'CLOUD_RECORDING',
  START_CALL = 'START_CALL',
  AUTOMATIC_CLOUD_RECORDING = 'AUTOMATIC_CLOUD_RECORDING',
  LIVE_CALL_ALERTS = 'LIVE_CALL_ALERTS',
  PRIVACY_AWARE_CLOUD_RECORDING = 'PRIVACY_AWARE_CLOUD_RECORDING',
  CLOUD_RECORDING_AI_SUMMARIZATION = 'CLOUD_RECORDING_AI_SUMMARIZATION',
  INSTITUTION_TEMPLATES = 'INSTITUTION_TEMPLATES',
  LMS = 'LMS',
  SCHEDULING = 'SCHEDULING',
  AVAILABILITY = 'AVAILABILITY',
  GLOBAL_MESSAGING = 'GLOBAL_MESSAGING',
  SITES = 'SITES',
  PROGRAMS = 'PROGRAMS',
  CUSTOM_ATTRIBUTES = 'CUSTOM_ATTRIBUTES',
  BRANDING = 'BRANDING',
  AI_COACH = 'AI_COACH',
  AI_SAFEGUARDING = 'AI_SAFEGUARDING',
  AI_SNIPPETS = 'AI_SNIPPETS',
  CHILD_MODE = 'CHILD_MODE',
  SMS_REMINDERS = 'SMS_REMINDERS',
  CONTROL_CENTER_ALERTS = 'CONTROL_CENTER_ALERTS',
  OBSERVER_MODE = 'OBSERVER_MODE',
  /** Gates Integrations → API key generation and Webhooks config entry points */
  API_AND_WEBHOOKS = 'API_AND_WEBHOOKS',
  /** Gates Integrations → LMS & SIS (Edlink) tab */
  LMS_AND_SIS = 'LMS_AND_SIS',
  RAISE_HAND = 'RAISE_HAND',
  EXPORT_BOARDS_AS_IMAGE = 'EXPORT_BOARDS_AS_IMAGE',
  /** Covers both export and import of .space files */
  EXPORT_IMPORT_SPACE_FILE = 'EXPORT_IMPORT_SPACE_FILE',
  /** Gates download of cloud recordings and transcripts */
  DOWNLOAD_CLOUD_RECORDINGS = 'DOWNLOAD_CLOUD_RECORDINGS'
}

// Updated enum name to be more specific and descriptive
export enum CapabilityDisplayMode {
  SHOW = 'SHOW', // Mode to display capability without any restrictions
  HIDE = 'HIDE' // Mode to completely hide the capability
}
